import moment from 'moment'
import 'moment/locale/it'
moment.locale('it')
export default moment
